// extracted by mini-css-extract-plugin
module.exports = {"header":"MainLayout_header__M65Ku","trigger":"MainLayout_trigger__3aqp9","logo":"MainLayout_logo__354QJ"};